import { render, staticRenderFns } from "./NotificationContainer.vue?vue&type=template&id=4a75d00c&scoped=true&"
import script from "./NotificationContainer.vue?vue&type=script&lang=ts&"
export * from "./NotificationContainer.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationContainer.vue?vue&type=style&index=0&id=4a75d00c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a75d00c",
  null
  
)

export default component.exports